<template>
  <div id="app">
    <router-view
      v-show="showPage"
      :key="$route.path"
      @ready="pageReady"
    />
    <app-spinner v-show="!showPage" />
  </div>
</template>

<script>
import AppSpinner from './components/AppSpinner.vue'
import NProgress from 'nprogress'

export default {
  name: 'App',
  components: {
    AppSpinner
  },

  data () {
    return {
      showPage: false
    }
  },

  created () {
    NProgress.configure({ speed: 200, showSpinner: false })
    NProgress.start()
    this.$router.beforeEach((to, from, next) => {
      this.showPage = false
      NProgress.start()
      next()
    })
  },

  methods: {
    pageReady () {
      this.showPage = true
      NProgress.done()
    }
  }
}
</script>

<style>
  @import "~nprogress/nprogress.css";

  body {
    margin: 0;
    font-family: Arial;
  }

  #nprogress .bar { 
    height: 4px;
  }
</style>
